import { Component, Vue } from 'vue-property-decorator';
import LocalStoreService from '@/store/local.store';
import BlobConverter from '@/utils/blobconverter';
import { McsisRole } from '@/models/constants/McsisRole';
import ParticipantService from '@/services/participant.service';
import { store, mutations } from '@/store/store';
import DynamicConfirmation from '@/components/DynamicConfirmation/DynamicConfirmation.vue';

@Component({
  components: {
    DynamicConfirmation,
  },
})
export default class Confirmation extends Vue {
  public confirmationMessage: string = '';
  public isInclusion: boolean = false;
  public roleParticipant: string = McsisRole[McsisRole.Participant];
  public showOrderConfirmationMessage: boolean = false;
  public isProFit: boolean = false;
  public isDoctor: boolean = false;
  public isPharmacist: boolean = false;
  public inclusionType: string = '';

  public get suName() { return this.$route.params.screening; }

  protected mounted() {
    this.inclusionType = LocalStoreService.getItem(LocalStoreService.localItemKeys.inclusionType);
    this.isProFit = store.state.isProFit;


    if (this.$route.query.mustOrderFit !== undefined &&
      this.$route.query.mustOrderFit.toString().toLowerCase() === 'true') {
      this.showOrderConfirmationMessage = true;
    }

    switch (this.inclusionType) {
        case 'Inclusion':
          this.confirmationMessage = 'confirmation.inclusion';
          this.isInclusion = true;
          break;
        case 'Exclusion':
          this.confirmationMessage = 'confirmation.exclusion';
          break;
        case 'Advice':
          this.confirmationMessage = 'confirmation.advice';
          break;
        default:
          this.confirmationMessage = 'confirmation.refusal';
          break;
    }

    this.$isInRole(McsisRole.Participant).then(async (isInRole: boolean) => {
      if (isInRole) {
        ParticipantService.logout();
      } else {
        // We do not logout the pro user so he can easily open an other dossier
        this.clearProData();

        if (store.state.isAuthenticated) {
            this.isDoctor = await this.$isInRole(McsisRole.Doctor);
            this.isPharmacist = await this.$isInRole(McsisRole.Pharmacist);
        }

        if (this.medColoOrPharFit) {
          this.downloadFile();
        }
      }
    });
  }

  /**
   * Show print follow up button only when doctor-colo or pharmacist-FIT
   */
  get medColoOrPharFit() {
    return (this.isDoctor && !this.isProFit) ||
      (this.isPharmacist && this.isProFit);
  }

  /**
   * Download the follow-up only if we already have a filename and it's an inclusion.
   */
  protected downloadFile(): void {
    const filename = LocalStoreService.getItem(LocalStoreService.localItemKeys.followUpFilename);
    if (filename) {
      const fileString = LocalStoreService.getItem(filename);
      if (fileString) {
        const blobPdf = BlobConverter.b64toBlob(fileString, 'application/pdf');
        if (!window.navigator.msSaveOrOpenBlob) {
          const url = window.URL.createObjectURL(blobPdf);
          const link = document.createElement('a');

          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          window.navigator.msSaveBlob(blobPdf, filename);
        }
      }
    }
  }

  /**
   * Clear data from the pro user. It clears the inclusion type and opened dossier,
   * and reset isDossierOpened and isProFit from global store.
   */
  protected clearProData(): void {
    mutations.setIsDossierOpened(false);
    mutations.setIsProFit(false);
    LocalStoreService.deleteItem(LocalStoreService.localItemKeys.inclusionType);
    LocalStoreService.deleteItem(LocalStoreService.localItemKeys.dossierId);
  }

  /**
   * Remove the PDF related data
   */
  protected beforeDestroy() {
    const filename = LocalStoreService.getItem(LocalStoreService.localItemKeys.followUpFilename);
    if (filename) {
      LocalStoreService.deleteItem(filename);
      LocalStoreService.deleteItem(LocalStoreService.localItemKeys.followUpFilename);
    }
  }
}

